var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginRightBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "login-right-bg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 340.531,
    height: 1041.684,
    viewBox: "0 0 340.531 1041.684",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 340.532,
    height: 1041.684,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M340.532,0V1041.684H0V419.823C0,213.246,146.073,40.8,340.532,0",
    fill: "#307fe2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginRightBg);
export default __webpack_public_path__ + "static/media/login-right-bg.db6f7aeb44bd4f0e0c0caa6075aaf8ad.svg";
export { ForwardRef as ReactComponent };